var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 34,
    viewBox: "0 0 18 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.16151 0.398335C2.6304 -0.132778 1.76929 -0.132778 1.23818 0.398335C0.707066 0.929447 0.707066 1.79055 1.23818 2.32166L8.03818 9.12166C8.56929 9.65277 9.43039 9.65277 9.96151 9.12166L16.7615 2.32166C17.2926 1.79055 17.2926 0.929447 16.7615 0.398335C16.2304 -0.132778 15.3693 -0.132778 14.8382 0.398335L8.99984 6.23667L3.16151 0.398335ZM3.16151 8.55833C2.6304 8.02722 1.76929 8.02722 1.23818 8.55833C0.707066 9.08944 0.707066 9.95055 1.23818 10.4817L8.03818 17.2817C8.56929 17.8128 9.43039 17.8128 9.96151 17.2817L16.7615 10.4817C17.2926 9.95055 17.2926 9.08944 16.7615 8.55833C16.2304 8.02722 15.3693 8.02722 14.8382 8.55833L8.99984 14.3967L3.16151 8.55833ZM1.23818 16.7183C1.76929 16.1872 2.6304 16.1872 3.16151 16.7183L8.99984 22.5567L14.8382 16.7183C15.3693 16.1872 16.2304 16.1872 16.7615 16.7183C17.2926 17.2494 17.2926 18.1105 16.7615 18.6417L9.96151 25.4417C9.43039 25.9728 8.56929 25.9728 8.03818 25.4417L1.23818 18.6417C0.707066 18.1105 0.707066 17.2494 1.23818 16.7183ZM3.16151 24.8783C2.6304 24.3472 1.76929 24.3472 1.23818 24.8783C0.707066 25.4094 0.707066 26.2705 1.23818 26.8017L8.03818 33.6017C8.56929 34.1328 9.43039 34.1328 9.96151 33.6017L16.7615 26.8017C17.2926 26.2705 17.2926 25.4094 16.7615 24.8783C16.2304 24.3472 15.3693 24.3472 14.8382 24.8783L8.99984 30.7167L3.16151 24.8783Z",
    fill: "url(#paint0_linear_18_511)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18_511",
    x1: 8.99984,
    y1: 0,
    x2: 8.99984,
    y2: 34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#A58D91",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A58D91"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.06b9f153604a7710fa7e6d2040193ef3.svg";
export { ForwardRef as ReactComponent };